// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"682":"0e8f6bbe","702":"1fb6f602","725":"d98cf064","771":"e6ddbe3a","855":"f5df6c2d"}[chunkId] + ".chunk.js";
};